import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ReportHtml } from 'tms-lib';
import {
  PickingListReport,
  ReleaseOrderReport,
  SalesOrderCollectionReport,
  SalesOrderConfirmationBalanceReport,
  SalesOrderConfirmationReport,
  SalesOrderPaymentReport,
} from '../../../models';
import { TmsWebBaseService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderReportsService extends TmsWebBaseService {
  constructor() {
    super('SalesOrderReports');
  }

  getSalesOrderConfirmationHtml(id: string): Observable<string> {
    return this.httpService
      .get<ReportHtml>(`${this.apiUrl}/SalesOrderConfirmationReportHtml?id=${id}`)
      .pipe(map((model) => model.html));
  }

  getSalesOrderConfirmationForPurchaseDelivery(id: string): Observable<SalesOrderConfirmationReport> {
    return this.httpService.get<SalesOrderConfirmationReport>(
      `${this.apiUrl}/SalesOrderConfirmationForPurchaseDelivery?id=${id}`,
    );
  }

  getAvailableStockPickingListReportHtml(id: string): Observable<string> {
    return this.httpService
      .get<ReportHtml>(`${this.apiUrl}/AvailableStockPickingListReportHtml?id=${id}`)
      .pipe(map((model) => model.html));
  }

  getSalesOrderProformaHtml(id: string): Observable<string> {
    return this.httpService
      .get<ReportHtml>(`${this.apiUrl}/SalesOrderProforma?id=${id}`)
      .pipe(map((model) => model.html));
  }

  getPickingList(id: string, supplierDocument: boolean, markAsPrinted: boolean): Observable<PickingListReport> {
    return this.httpService.get<PickingListReport>(
      `${this.apiUrl}/PickingList?id=${id}&supplierDocument=${supplierDocument}&markAsPrinted=${markAsPrinted}`,
    );
  }

  getSalesOrderBalances(id: string): Observable<SalesOrderConfirmationBalanceReport> {
    return this.httpService.get<SalesOrderConfirmationBalanceReport>(
      `${this.apiUrl}/SalesOrderConfirmationBalances/${id}`,
    );
  }

  getSalesOrderPayments(id: string): Observable<SalesOrderPaymentReport> {
    return this.httpService.get<SalesOrderPaymentReport>(`${this.apiUrl}/SalesOrderPayment/${id}`);
  }

  getReleaseOrder(id: string): Observable<ReleaseOrderReport> {
    return this.httpService.get<ReleaseOrderReport>(`${this.apiUrl}/ReleaseOrder/${id}`);
  }

  getSalesOrderCollection(id: string): Observable<SalesOrderCollectionReport> {
    return this.httpService.get<SalesOrderCollectionReport>(`${this.apiUrl}/SalesOrderCollection/${id}`);
  }
}
